import "./scroll-fade.css";

export const createScrollFade = () => {};
